// The first one is for more frequent refetching, and the second is for less frequent
import { ENV_CONSTS } from './env-consts.ts';
import { type HorseName } from './racing-game/consts.ts';
import { type StableName } from './racing-game/horses.ts';

export const BLOCK_REFETCH_FREQUENCY_1 = 2n;
export const BLOCK_REFETCH_FREQUENCY_2 = 3n;
export const BLOCK_REFETCH_FREQUENCY_3 = 15n;

export const BLOCKCHAIN_CLOSED_BETS_BEFORE_ROUND_END_TIME_MS =
  Number(ENV_CONSTS.BLOCKCHAIN_CLOSED_BETS_BEFORE_ROUND_END_TIME) || 5000;

export const blockchainTokensMap: Array<HorseName | StableName> = [
  'doge',
  'shib',
  'pepe',
  'bonk',
  'wif',
  'floki',
  'brett',
  'popcat',
];

export const blockchainTokensMapWithGroups: Array<HorseName | StableName> = [
  ...blockchainTokensMap,
  'A',
  'B',
];
